var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Layout', {
    staticClass: "main-layout"
  }, [_c('Header', {
    staticClass: "myheader"
  }, [_vm.sysMenuMode === '2' ? _c('a', {
    staticClass: "pull-left sys-title",
    attrs: {
      "href": ""
    }
  }, [_vm._v("噢易云产品试用申请系统")]) : _vm._e(), _c('Dropdown', {
    staticClass: "username pull-right",
    attrs: {
      "trigger": "click"
    },
    on: {
      "on-click": _vm.selectMode
    }
  }, [_c('Avatar', {
    staticStyle: {
      "background-color": "#87d068",
      "cursor": "pointer"
    },
    attrs: {
      "icon": "ios-person",
      "title": _vm.user.username
    }
  }), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "userInfo"
    }
  }, [_vm._v("帐号信息")]), _c('DropdownItem', {
    attrs: {
      "name": "changePassword"
    }
  }, [_vm._v("修改密码")]), _c('DropdownItem', {
    attrs: {
      "name": "logout"
    }
  }, [_vm._v("退出")])], 1)], 1), _vm.$getOperateAuth('dev_product_del_license') ? _c('a', {
    staticClass: "pull-right btn-activation",
    attrs: {
      "href": "disActivation.html",
      "target": "_blank"
    }
  }, [_vm._v("注销授权")]) : _vm._e(), _c('a', {
    staticClass: "pull-right btn-activation",
    attrs: {
      "href": "activation.html",
      "target": "_blank"
    }
  }, [_vm._v("获取授权文件")])], 1), _c('Layout', [_vm.sysMenuMode === '1' ? _c('Button', {
    staticClass: "btn-drawer",
    attrs: {
      "shape": "circle",
      "icon": "md-menu"
    },
    on: {
      "click": function click($event) {
        _vm.showMenuDrawer = true;
      }
    }
  }) : _vm._e(), _vm.sysMenuMode === '1' ? _c('Drawer', {
    attrs: {
      "title": "系统菜单",
      "placement": "left",
      "closable": false
    },
    model: {
      value: _vm.showMenuDrawer,
      callback: function callback($$v) {
        _vm.showMenuDrawer = $$v;
      },
      expression: "showMenuDrawer"
    }
  }, [_c('SysMenu')], 1) : _vm._e(), _vm.sysMenuMode === '2' ? _c('Sider', {
    staticClass: "main-sider",
    attrs: {
      "hide-trigger": ""
    }
  }, [_c('SysMenu')], 1) : _vm._e(), _c('Content', {
    style: {
      padding: '0 20px'
    }
  }, [_c('router-view')], 1), _c('UserInfoModal', {
    attrs: {
      "title": "账号信息",
      "user": _vm.user
    },
    on: {
      "close": _vm.onModalClose
    },
    model: {
      value: _vm.userInfostatus,
      callback: function callback($$v) {
        _vm.userInfostatus = $$v;
      },
      expression: "userInfostatus"
    }
  }), _c('ChangePassword', {
    attrs: {
      "title": "修改密码"
    },
    model: {
      value: _vm.changePasswordstatus,
      callback: function callback($$v) {
        _vm.changePasswordstatus = $$v;
      },
      expression: "changePasswordstatus"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };